import { render, staticRenderFns } from "./scoreShop.vue?vue&type=template&id=53f4612d&scoped=true"
import script from "./scoreShop.vue?vue&type=script&lang=js"
export * from "./scoreShop.vue?vue&type=script&lang=js"
import style0 from "./scoreShop.vue?vue&type=style&index=0&id=53f4612d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f4612d",
  null
  
)

export default component.exports